// @flow
import * as React from 'react'
import { Icon, hooks } from '../../index'
import * as text from '../text'
import { media, colors } from '@toggl/style'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

type Props = {
  children: React.Node,
  contentPadding?: number,
  top: [number, number],
  onClose: () => void,
}

const ExpandedMenu = ({ children, contentPadding, top, onClose }: Props) => {
  const [open, setOpen] = React.useState(!!children)

  React.useEffect(() => {
    setOpen(!!children)
  }, [children])

  const isDesktop = hooks.useMediaQuery(media.mqbp[1])

  return (
    <>
      {
        <Root open={open} top={top} contentPadding={contentPadding}>
          <StyledMenu open={open} compact={!isDesktop && open}>
            {!isDesktop && (
              <StyledGoBack
                onClick={() => {
                  onClose()
                  setOpen(false)
                }}
              >
                <Icon.ArrowBigLeft color={colors.darkPurple} />
                <span>Back</span>
              </StyledGoBack>
            )}
            <ContentWrapper>{children}</ContentWrapper>
          </StyledMenu>
        </Root>
      }
    </>
  )
}

const openCss = css`
  height: 420px;
  max-height: 420px;
`

const Root = styled.div`
  width: 100%;
  z-index: 999999999;
  position: absolute;
  background: ${(p) => p.theme.background};
  padding-left: ${(p) => (p.contentPadding ? `${p.contentPadding}px` : '8%')};
  top: ${(p) => p.top[0]}px;
  transition: all 300ms linear;
  overflow: hidden;

  ${media.mq[1]} {
    top: ${(p) => p.top[1]}px;
    background: ${(p) => p.theme.backgroundDesktop};
    height: 0;
    ${(p) => (p.open ? openCss : '')}
  }
`

const StyledGoBack: React.ComponentType<any> = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
  & > span {
    margin-left: 20px;
    ${text.paragraph3};
    color: ${colors.darkPurple};
  }

  svg {
    width: 30px;
  }
`

const StyledMenu: React.ComponentType<any> = styled.div`
  flex-direction: column;
  display: ${(p) => (p.open ? 'flex' : 'none')};

  ${media.mq[1]} {
    display: ${({ open }) => (open ? 'block' : 'none')};
    max-width: 1200px;
  }
`

const ContentWrapper = styled.div`
  padding-top: 27px;

  min-height: calc(100vh - 64px);

  ${media.mq[1]} {
    padding-top: 8px;
    min-height: inherit;
  }
`

export default ExpandedMenu
